import { GAMES_ARTIFACTS } from '@alatzidis/games'
import { SOUND_ARTIFACTS } from '@alatzidis/sound'
import { CHESS_ARTIFACTS } from '@alatzidis/chess'
import { NOTES_ARTIFACTS } from '@alatzidis/notes'
import { RENDER_ARTIFACTS } from '@alatzidis/render'

export const ARTIFACTS_BY_SECTION = {
  games: GAMES_ARTIFACTS,
  sound: SOUND_ARTIFACTS,
  chess: CHESS_ARTIFACTS,
  notes: NOTES_ARTIFACTS,
  render: RENDER_ARTIFACTS,
} as const
